import { css } from '@emotion/react';

/**
 * front-lib の `@ps-smart-cp/design-tokens/styles.css` の代役。あちらはまだ registry に
 * 登録されていないため install できないので、新UI（v2）が使う分の宣言だけをここに置く。
 * install できるようになったら、この file を削除して、注入している `<Global>` を
 * `import '@ps-smart-cp/design-tokens/styles.css'` に差し替える。component 側は変わらない。
 *
 * 値を書き足すのはこの file だけ。変数名は front-lib の `tokens/semantic/` にある役割の
 * パスを kebab-case にしたものに限る（`space.insetLoose` → `--ps-space-inset-loose`）。
 */
export const designTokensRootStyle = css`
  :root {
    --ps-color-text-primary: #303030;
    --ps-color-text-secondary: #686868;
    --ps-color-text-heading: #002169;
    --ps-color-background-canvas: #ffffff;
    --ps-color-background-surface: #ffffff;
    --ps-color-background-subtle: #f6f6f6;
    --ps-color-background-muted: #eeeeee;
    --ps-color-background-selected: #f2f6ff;
    --ps-color-border-default: #dddddd;
    --ps-color-border-strong: #b0b0b0;
    --ps-color-brand-default: #0c43ad;
    --ps-color-status-error-foreground: #d32f2f;
    --ps-color-status-error-border: #fdafa6;
    --ps-color-status-error-surface: #fff3f1;

    --ps-space-hairline: 2px;
    --ps-space-inline: 4px;
    --ps-space-stack: 8px;
    --ps-space-inset: 12px;
    --ps-space-inset-loose: 16px;

    --ps-border-width-divider: 1px;
    --ps-border-width-indicator: 3px;

    --ps-radius-container: 8px;

    --ps-control-default: 36px;

    --ps-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.06);

    --ps-transition-default-duration: 200ms;
    --ps-transition-default-easing: cubic-bezier(0.25, 0.1, 0.25, 1);

    --ps-text-annotation-size: 11px;
    --ps-text-annotation-line-height: 1;
    --ps-text-body-size: 14px;
    --ps-text-body-weight: 400;

    --ps-layer-header: 1200;
  }
`;
